import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_USER_PROFILE } from '../queries/userQueries';
import { useFollow } from "../hooks/useFollow";
import Spinner from "./Spinner";

export default function SuggestedUser({ authUser, user }) {
  const { refetch } = useQuery(GET_USER_PROFILE, {
	variables: { id: user.id },
  })

  /*const { data: followingData, loading: followingLoading, error: followingError } = useQuery(GET_FOLLOWING, {
	variables: { id: authUser.id }
  })*/

  const { followUnfollow, isLoading } = useFollow()

  //if (followingLoading) return <Spinner />
  //if (followingError) return <p>Error loading following data: {followingError.message}</p>
  const amIFollowing = authUser.following.some((follow) => {
    return follow.id === user?.id
  })

  return (
    <div
	  onClick={() => refetch()}
	  className='d-flex flex-column items-align-start my-2 mx-auto'
	  key={user.id}
	>
	  <Link className='d-flex flex-column flex-xl-row link-underline link-underline-opacity-0 text-center my-2' to={`/users/${user.id}`}>
		<div className='avatar me-2'>
		  <img
		    src={user.profileImg || "/avatar-placeholder.png"}
		    className="rounded-circle"
		    style={{ width: '50px', height: '50px' }}
			alt=""
		  />
		</div>

		<div className='d-flex flex-column items-align-center rfs-4 text-white'>
		  <span className='font-semibold tracking-tight truncate w-28'>
		    {user.fullname}
		  </span>
		  {/*<span className='text-sm text-slate-500'>@{user.username}</span>*/}
		</div>
	  </Link>

      <div className="text-center">
		<button className='btn btn-violet btn-sm' onClick={(e) => {
		  e.preventDefault();
		  followUnfollow(authUser?.id, user.id)
		}}>
		  {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
		  {!isLoading && amIFollowing && "Unfollow"}
		  {!isLoading && !amIFollowing && "Follow"}
		</button>
	  </div>
	</div>
  )
}
